
export const traduzirNomeColunaMarkup = ({ nomeColuna, exibirNomeReferencia }: { nomeColuna: string, exibirNomeReferencia: boolean}) => {

    const mapColunasPesquisarProdutos = {
        "Codigo" : exibirNomeReferencia ? "Referencia" : "Código",
        "Descricao": "Descrição",
        "CodigoFabricante": "Código do Fabricante",
        "Unidade": "Unid.",
        "MarkupMinimoPapelaria": "Markup Mínimo",
        "ValorMargemZeroPapelaria": "Valor Margem 0",
        "PrecoAtualPapelaria": "Preço Atual",
        "MarkupRealPapelaria": "Markup Real",
        "CustoRealPapelaria": "Custo Real",
        "MarkupReal": "Markup Real *",
        "MarkupRealSimples": "Markup Real**", // 452507
        "CustoReal1": "Custo Real *",
        "CustoAnterior": "Custo Anterior",
        "CustoAtual": "Custo Atual",
        "CustoReal": "Custo Real",
        "CustoUltimaPesquisa": "Custo Últ. Pesquisa",
        "MarkupUltimaPesquisa": "Markup Últ. Pesquisa",
        "MarkupPrecoVendaUltimaPesquisa": "MK Preço de Venda e Custo da Últ. Pesquisa",
        "MargemZeroUltPesquisa": "Margem Zero", // 449132
        "MargemLucro": "Margem Lucro",
        "MargemLucroAnterior": "Margem Lucro Ant.",
        "MargemLucroReal": "Margem Lucro Real",
        "MargemLucroZeroPorMl": "Margem Lucro Por Margem 0",
        "MarkupAnterior": "Markup Anterior",
        "MarkupMargemAtual": "Markup Atual",
        "MarkupBruto": "Markup Bruto %",
        "MarkupBrutoValorPresente": "Markup Bruto Vr. Pres.",
        "MarkupMargem": "Markup Margem 0",
        "MarkupMargemPorMargem": "Markup Por Custo de Margem 0",
        "MarkupMargemValorPresente": "Markup Margem Vr. Pres.",
        "MarkupRealValorPresente": "Markup Real Vr. Pres.",
        "MarkupRealPorMargem": "Markup Real Por Margem",
        "PrecoAnterior": "Preço Anterior",
        "PrecoAtualValorPresente": "Preço Atual Vr. Pres.",
        "PrecoCompra": "Preço Compra",
        "PrecoCustoMl": "Preço Custo por Margem de Lucro",
        "PrecoLiquidoMl": "Preço Líquido por Margem de Lucro",
        "PrecoVendaMl": "Preço Venda por Margem de Lucro",
        "Quantidade": "Quantidade"
    }

    return nomeColuna in mapColunasPesquisarProdutos ? mapColunasPesquisarProdutos[nomeColuna] : null
} 